export const MuiRadio = {
  styleOverrides: {
    root: {
      color: 'rgba(221, 221, 234, 1)',
      height: '24px',
      width: '24px',

      '&.Mui-checked': {
        color: 'rgba(1, 128, 148, 1)',
      },
    },
  },
};
